import { Box as MantineBox } from '@mantine/core'
import { BoxProps } from './box.types'

export const Box = ({ ...props }: BoxProps) => <MantineBox {...props} />
